import { render, staticRenderFns } from "./PaymentTermListTable.vue?vue&type=template&id=9c940998"
import script from "./PaymentTermListTable.vue?vue&type=script&lang=js"
export * from "./PaymentTermListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports